<template>
  <div class="afterSaleStatistics">
    <module-title title="版本信息">
      <div class="right">
        <el-button
          type="primary"
          size="medium"
          icon="el-icon-arrow-left"
          @click="$emit('back')"
        >
          返回
        </el-button>
      </div>
    </module-title>
    <div class="afterSaleStatistics-main">
      <el-form
        ref="afterSaleStatisticsForm"
        :model="searchForm"
        :inline="true"
        label-position="right"
        label-width="100px"
      >
        <el-form-item label="名称：" prop="name">
          <el-input
            v-model="searchForm.name"
            name="name"
            maxlength="10"
            placeholder="输入名称"
            class="handle-form-input"
            clearable
          />
        </el-form-item>

        <el-form-item style="margin-left: 50px">
          <el-button
            type="primary"
            size="medium"
            icon="el-icon-search"
            @click="handleSearchFilter"
          >
            查询
          </el-button>
        </el-form-item>
      </el-form>
      <el-table
        v-loading="listLoading"
        :data="versionInfoList"
        highlight-current-row
        fit
        element-loading-text="Loading"
        class="list-table"
      >
        <el-table-column type="index" width="55" align="center" label="序号" />
        <el-table-column label="名称" align="center" prop="appName" />
        <el-table-column label="升级时间" prop="createDate" align="center" />
        <el-table-column label="版本号" prop="versionName" align="center" />
        <el-table-column label="迭代号" prop="versionNumber" align="center" />
      </el-table>
      <pagination
        :total="searchForm.total"
        :page.sync="searchForm.pageNum"
        :limit.sync="searchForm.pageSize"
        @pagination="pageCurriculumList"
        @handleSizeChange="handleSizeChange"
      />
    </div>
  </div>
</template>

<script>

import { getDeviceLatestVersion } from '@/api/productOperation/mrDesk/statistics';
export default {
  name: 'VersionInfoStatistics',
  props: {
    dataPrpos: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      // 搜索表单
      searchForm: {
        deviceNo: '',
        name: '',
        pageNum: 1,
        total: 0,
        pageSize: 10
      },
      listLoading: false,
      dialogDetailVisible: false,
      versionInfoList: []
    };
  },

  mounted() {
    this.fetchVersionInfoList();
  },
  methods: {
    // 分页
    pageCurriculumList(obj) {
      this.searchForm.pageNum = obj.page;
      this.fetchVersionInfoList();
    },
    // 分页条数变化
    handleSizeChange(obj) {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = obj.limit;
      this.fetchVersionInfoList();
    },
    // 条件查询
    handleSearchFilter() {
      this.searchForm.pageNum = 1;
      this.searchForm.pageSize = 10;
      this.fetchVersionInfoList();
    },

    // 获取售后数据
    fetchVersionInfoList() {
      this.listLoading = true;
      var option = {
        deviceNo: this.dataPrpos.deviceNo,
        name: this.searchForm.name,
        pageNum: this.searchForm.pageNum,
        pageSize: this.searchForm.pageSize
      };
      getDeviceLatestVersion(option)
        .then((res) => {
          if (res.data && res.data.list && res.data.list.length) {
            this.versionInfoList = res.data.list;
            this.searchForm.total = res.data.total;
          } else {
            this.versionInfoList = [];
            this.searchForm.total = 0;
          }
          this.listLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.versionInfoList = [];
          this.total = 0;
          this.listLoading = false;
        });
    }
  }
};
</script>
<style lang="scss" scoped>
.afterSaleStatistics {
  .handle-form-input {
    width: 200px;
  }
  .manager-info {
    display: flex;
    ul {
      margin-left: 60px;
      width: 100%;
      min-width: 220px;
      li {
        label {
          margin-right: 10px;
        }
        margin-bottom: 20px;
      }
    }
  }
}
</style>
